import axios from 'axios';
import store from '../store'
import verifyAuth from '../services/utilities' 

class DepayRepository{

    constructor() {
        this.basePath = store.state.backend;
    }

    getDepayAccepts() {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/depay/accepts`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    trackPayment(paymentInfo) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/depay/track`,paymentInfo,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    pollDepayPaymentStatus(payment) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/depay/status`,payment,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }
    
}

export default new DepayRepository();
